var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayDiagonalArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53538 0.488281C8.7564 0.488281 8.96836 0.576079 9.12464 0.732359C9.28092 0.888639 9.36872 1.1006 9.36872 1.32161V7.21495C9.36872 7.43596 9.28092 7.64792 9.12464 7.8042C8.96836 7.96048 8.7564 8.04828 8.53538 8.04828C8.31437 8.04828 8.10241 7.96048 7.94613 7.8042C7.78985 7.64792 7.70205 7.43596 7.70205 7.21495V3.33411L2.05288 8.98245C1.89572 9.13425 1.68521 9.21824 1.46672 9.21634C1.24822 9.21445 1.03921 9.1268 0.884703 8.9723C0.730196 8.81779 0.642555 8.60878 0.640657 8.39028C0.638758 8.17178 0.722753 7.96128 0.874552 7.80411L6.52288 2.15495H2.64288C2.42187 2.15495 2.20991 2.06715 2.05363 1.91087C1.89735 1.75459 1.80955 1.54263 1.80955 1.32161C1.80955 1.1006 1.89735 0.888639 2.05363 0.732359C2.20991 0.576079 2.42187 0.488281 2.64288 0.488281H8.53538Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDiagonalArrow);
export default __webpack_public_path__ + "static/media/GrayDiagonalArrow.f9ce41cc666372ce3330efe3c6e41abd.svg";
export { ForwardRef as ReactComponent };